module.exports = "/_next/static/images/2be66b795326359036f2a634898d0982-cards-and-device@2x.jpg.webp";